<template>
  <div
    v-if="highlightingLabel && visible"
    class="highlighting-label"
    :style="labelStyle"
  >
    {{ highlightingLabel.name }}
  </div>
</template>

<script>
import HighlightingLabelJS from '@/objects/HighlightingLabel';

export default {
  name: 'HighlightingLabel',
  props: {
    label: Object,
    visible: Boolean,
  },
  computed: {
    labelStyle() {
      return this.highlightingLabel.getStyle();
    },
  },
  data() {
    return {
      highlightingLabel: null,
    };
  },
  watch: {
    label() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.highlightingLabel = new HighlightingLabelJS(this.label);
    },
  },
};
</script>
